const state = {
  default: [
    'doc',
    'pdf',
    'ppt',
    'xls',
    'archive_doc',
    'audio',
    'video',
    'image',
    'archive_mm',
    'article',
    'event',
    'gdoa_event',
    'campaign',
    'project',
    'case_study',
    'page',
    'blog',
    'digital_publication',
  ],
  statuses: ['published', 'draft', 'disabled', 'unlisted'],
}

export default {
  state,
}
